import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";

const COACH_IMG =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_coast2coast-hoops/artifacts/lk3va9e0_Coaching%20Freethrow%20Shot.jpeg";

const STATS = [
  { k: "20", label: "PPG · Sydney Comets YL" },
  { k: "3×", label: "Best & Fairest — Marcellin 1sts" },
  { k: "2×", label: "MVP · Regional & Conference School Finals" },
  { k: "1×", label: "NSWCCC Representative" },
];

const rise = {
  initial: { y: 40, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, margin: "-15%" },
  transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
};

export const CoachBio = () => {
  return (
    <section
      id="about"
      data-testid={TID.bio}
      className="relative py-32 md:py-48 px-6 md:px-12"
    >
      <div className="max-w-[1600px] mx-auto grid grid-cols-12 gap-6 md:gap-12">
        {/* Left column: portrait */}
        <div className="col-span-12 md:col-span-6 relative">
          <motion.div
            initial={{ opacity: 0, scale: 1.08 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            className="relative aspect-[3/4] overflow-hidden border border-white/10"
          >
            <div
              className="absolute inset-0 bg-cover bg-center contrast-110 spotlight-img"
              style={{ backgroundImage: `url(${COACH_IMG})`, backgroundPosition: "center 15%" }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#060b14] via-transparent to-transparent" />

            <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between font-mono text-[10px] uppercase tracking-[0.3em] text-white/70">
              <span>Owen Levy — Head Coach of C2C</span>
            </div>
          </motion.div>

          <div className="mt-6 flex items-start justify-between gap-6 font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">
            <div className="flex flex-col gap-1">
              <span>Sydney &middot; Eastern Suburbs</span>
              <span className="text-white/35">Travel considered on request</span>
            </div>
            <span className="text-right">Coach on court</span>
          </div>
        </div>

        {/* Right column: bio */}
        <div className="col-span-12 md:col-span-6 md:pl-6 lg:pl-14 flex flex-col justify-center">
          <motion.div {...rise} className="chapter-num mb-6">
            Meet your coach — Owen Levy
          </motion.div>

          <motion.h2
            {...rise}
            transition={{ ...rise.transition, delay: 0.05 }}
            className="font-display uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight"
          >
            Rep experience.
            <br />
            <span className="text-[#2a5fdb]">Real</span> development.
          </motion.h2>

          <motion.p
            {...rise}
            transition={{ ...rise.transition, delay: 0.15 }}
            className="mt-8 text-white/75 text-base md:text-lg leading-relaxed max-w-xl"
          >
            I currently coach at Sydney Boys High School, was the assistant
            coach of the U14 Sydney Comets representative team for the 2026
            season, captained the 2025 Marcellin College Randwick 1st
            basketball team, and currently compete in the Sydney Comets
            Youth League representative program, averaging 20+ points per
            game.
          </motion.p>

          <motion.p
            {...rise}
            transition={{ ...rise.transition, delay: 0.2 }}
            className="mt-6 text-white/60 text-base leading-relaxed max-w-xl"
          >
            I&apos;m building Coast 2 Coast to give the next generation of
            Eastern Suburbs players the same edge I got — patient reps, honest
            coaching, and a belief they can chase this game as far as they
            want to.
          </motion.p>

          <motion.div
            {...rise}
            transition={{ ...rise.transition, delay: 0.3 }}
            className="mt-14 grid grid-cols-2 gap-x-8 gap-y-10 border-t border-white/10 pt-10"
          >
            {STATS.map((s) => (
              <div key={s.label}>
                {s.k ? (
                  <>
                    <div className="font-display text-5xl md:text-6xl text-white leading-none">
                      {s.k}
                    </div>
                    <div className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-white/55">
                      {s.label}
                    </div>
                  </>
                ) : (
                  <div className="font-display uppercase text-3xl md:text-4xl text-white leading-[0.95] tracking-tight">
                    {s.label}
                  </div>
                )}
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};
